import { Button } from "../../components/Button";
import { HeroWrapper, HeroBadge, HeroTitle, HeroCtas, HeroCTA, HeroSubtitle, HeroContent, HeroImage } from "../../components/pages/Hero";
import Head from "next/head";
import { HugeCTATitle, HugeCTAWrapper } from "../../components/pages/HugeCTA";
import { Icon } from "../../components/Icon";
import { GetAllDatoImages, convertNumberedKeysToArrays, replaceImageValues } from "../../components/helpers";
import { GradientDivider, GradientDividerTop } from "../../components/GradientDivider";
import { BenefitsCard, BenefitsCardDescription, BenefitsCardIcon, BenefitsCardTitle, BenefitsCards, BenefitsTitle, BenefitsWrapper } from "../../components/pages/Benefits";
import { useStoreUTM } from "../../components/hooks/storeUTM";
import ParallaxHero from "../../components/ParallaxHero";
import Layout from "../../components/layouts/HomeLayout";
import FaucetPage from "../../components/pages/platform/FaucetPage";
import { Flex } from "@radix-ui/themes";
const faucetPage = require("../../data/faucet-page.json");

export default function LandingPage({ content, handleToast, user, busy, setMobileMenu, mobileMenuIsOpen, isTransparent }) {
    const ogImage = content["hero-image"].src.replace("https://www.datocms-assets.com/", "");
    useStoreUTM();
    
    return <>
        <Layout handleToast={handleToast} user={user} busy={busy} setMobileMenu={setMobileMenu} mobileMenuIsOpen={mobileMenuIsOpen} isTransparent={isTransparent}>
            <Head>
                <title>{content.meta.title}</title>
                <meta name="description" content={content.meta.description} />
                <meta name="keywords" content="developer, faucet, testnet" />
                <meta property="og:description" content={content.meta.description} />
                <meta property="og:title" content="Testnet Faucet | Covalent" />
                <link rel="canonical" href="https://www.covalenthq.com/faucet/" />
                <meta name="og:image" content={`https://covalent-og.vercel.app/api/og?title=${encodeURI(content.meta.title)}&subtitle=${encodeURI("dev tools")}&dato=${ogImage}`} />
                <link  rel="preload"  as="image" href="https://www.datocms-assets.com/86369/1700775331-particles-6.jpg" />
            </Head>
            <div className="landing-page">
                <ParallaxHero imageUrl="https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?dpr=0.25&fm=webp 960w,https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?dpr=0.5&fm=webp 1920w,https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?dpr=0.75&fm=webp 2880w,https://www.datocms-assets.com/86369/1700775331-particles-6.jpg?fm=webp 3840w">
                    <HeroWrapper dark>
                        <div className="overlay" />
                        <GradientDivider />
                        <HeroContent>
                            <HeroBadge>
                        Developer Tools
                                <div className="flex-center">
                                    <Icon icon="chevron-right" size="0.7" />
                                </div>
                        Faucet
                            </HeroBadge>
                            <HeroTitle>
                        Testnet Faucet
                            </HeroTitle>
                            <HeroSubtitle>
                        Testnet tokens delivered to your wallet across dozens of blockchains.
                            </HeroSubtitle>
                            <HeroCtas>
                                <HeroCTA><Button href="/faucet/#form">Access the Faucet</Button></HeroCTA>
                            </HeroCtas>
                        </HeroContent>
                        <HeroImage image={content["hero-image"]} />
                    </HeroWrapper>
                    <BenefitsWrapper dark>
                        <BenefitsTitle>
                    Faucet Details
                        </BenefitsTitle>
                        <BenefitsCards>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1679953835-property-1-linea-icon-white.svg"} />
                                <BenefitsCardTitle>
                            Linea Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 0.02 ETH
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1677538323-property-1-base-icon-white.svg"} />
                                <BenefitsCardTitle>
                            Base Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 0.02 ETH
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1677538585-property-1-mantle-icon-white.svg"} />
                                <BenefitsCardTitle>
                            Mantle Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 100 MNT
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1670007891-scroll.svg"} />
                                <BenefitsCardTitle>
                            Scroll Alpha & Sepolia Testnet Faucets
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 0.02 ETH
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1681157624-property-1-horizen-icon-white.svg"} />
                                <BenefitsCardTitle>
                            Horizen Gobi Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 0.02 ETH
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1670347457-optimism-icon-white.svg"} />
                                <BenefitsCardTitle>
                            Optimism Goerli Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 0.02 ETH
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1693503842-zetachain-icon-white.svg"} />
                                <BenefitsCardTitle>
                            ZetaChain Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 0.02 ZETA
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1686072650-arbitrum-icon-white.svg"} />
                                <BenefitsCardTitle>
                            Arbitrum Goerli Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 0.02 ETH
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1677870347-property-1-polygon-zkevm-icon-white.svg"} />
                                <BenefitsCardTitle>
                            Polygon Mumbai Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 0.02 MATIC
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1686152918-avalanche-icon-white.svg"} />
                                <BenefitsCardTitle>
                            Avalanche Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 0.02 AVAX
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1669933123-cronos.svg"} />
                                <BenefitsCardTitle>
                            Cronos Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Drips 50 TCRO
                                </BenefitsCardDescription>
                            </BenefitsCard>
                            <BenefitsCard>
                                <BenefitsCardIcon src={"https://www.datocms-assets.com/86369/1669653891-eth.svg"} />
                                <BenefitsCardTitle>
                            Sepolia Testnet Faucet
                                </BenefitsCardTitle>
                                <BenefitsCardDescription>
                            Coming soon
                                </BenefitsCardDescription>
                            </BenefitsCard>
                        </BenefitsCards>
                    </BenefitsWrapper>
                    <HugeCTAWrapper dark>
                        <GradientDivider height={200} />
                        <GradientDividerTop height={200} />
                        <Flex gap="6" justify="between" height="max-content" width="100%" wrap={"wrap"}>
                            <div className="top-section center-self">
                                <HugeCTATitle>
                                    Get Test Tokens Delivered<br/>To Your Wallet
                                </HugeCTATitle>
                            </div>
                            <div className="signup-box">
                                <div id="form" />
                                <FaucetPage/>
                            </div>
                        </Flex>
                    </HugeCTAWrapper>
                </ParallaxHero>
                <style jsx>{`
        .landing-page{
            overflow:hidden;
        }
        .center-self {
            place-self: center;
        }
        #form {
            visibility: none;
            position: absolute;
            top: -150px;
        }
        .signup-box {
            background-image: linear-gradient(135deg,#00d8d521 0%,#ff4c8b33 100%);
            padding: 2rem;
            border-radius: calc(var(--border-radius) * 2);
            position: relative;
            border: 1px solid var(--code-border);
            transition: all 0.2s ease-in-out;
        }
        .signup-box:hover {
            border: 1px solid var(--pink);
            transition: all 0.2s ease-in-out;
        }
        @keyframes backgroundGradient {
            0% {
                background-position: 0% 50%;
                transform: scale(1.01);
            }
            100% {
                background-position: 100% 50%;
                transform: scale(0.98);
            }
        }

        :global(.signup-box::before) {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background-image: linear-gradient(45deg, #ff4c8b80, var(--teal));
            z-index: -1;
            filter: blur(5px);
            border-radius: calc(var(--border-radius) * 2);
            animation: backgroundGradient 4s ease-in-out infinite alternate;
            background-size: 200% 200%;
            // opacity: 0.85;
            transition: all 0.2s ease-in-out;
        }

        :global(.signup-box:hover::before) {
            filter: blur(25px);
            transition: all 0.2s ease-in-out;
            background-image: linear-gradient(45deg, var(--pink), var(--teal));
        }

        :global(.signup-box::after) {
            content: "";
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: var(--covalent-dark-blue);
            z-index: -1;
            border-radius: calc(var(--border-radius) * 2);
            // opacity: 0.85;
        }
        :global(.signup-box::after) {
            background-image: linear-gradient(135deg,#00d8d521 0%,#ff4c8b33 100%);
        }
        .flex {
            gap: 2rem;
            z-index: 1;
        }
        .overlay {
            position: absolute;
            top: 0;
            left: 0;
            width: 100%;
            height: 100%;
            background: #00042661;
            z-index: 0;
        }

        .video-bg{
            display:block;
        }

        @media (max-width: 768px) {
            .video-bg{
                display:none;
            }
            .static-bg{
                display:block;
            }
        }
        @media (max-width: 768px) {
            .flex {
                flex-direction: column;
            }
        .place-items-center {
            place-items: center;
        }
    `}</style>
            </div>
        </Layout>
    </>;
}

export async function getStaticProps() {
    const content = faucetPage;
    const images = await GetAllDatoImages();
    const transformedContent = convertNumberedKeysToArrays(replaceImageValues(content, images));

    return {
        props: {
            component: "LandingPage",
            content: transformedContent,
        },
    };
}
